/* External */
import {
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';

/* Storage */
import { fetchSeasonById, selectSeasonById } from '../storage/seasons';
import useRequestAndDelete from './useRequestAndDelete';

/* Utils */
import { STATUS_TYPES } from '../utils/constants';

export default function useFetchSeason({
  showId,
  seasonNumber,
  requiredProps = [],
  sourceProvider,
}) {
  const dispatchTrigger = useRef(false);
  const dispatch = useDispatch();
  const seasonSelector = useMemo(
    // TODO: Find a more scalable way to get the season id
    () => selectSeasonById(`${showId}_${seasonNumber}`),
    [showId, seasonNumber],
  );
  const season = useSelector(seasonSelector);

  const [requestId, setRequestId] = useState(undefined);

  const request = useRequestAndDelete(requestId);

  useEffect(() => {
    dispatchTrigger.current = false;
    setRequestId(undefined);
  }, [seasonNumber]);

  useEffect(() => {
    const hasProperties = season && requiredProps.every((prop) => !!season[prop]);
    if (
      (!season || !hasProperties)
      && (seasonNumber || seasonNumber === 0)
      && !dispatchTrigger.current
    ) {
      const action = fetchSeasonById({
        showId,
        seasonNumber,
        sourceProvider,
      });
      setRequestId(action.requestId);
      dispatch(action);
      dispatchTrigger.current = true;
    }
  }, [dispatch, requiredProps, season, seasonNumber, showId, sourceProvider]);

  return {
    season,
    isFetching: (!request && !season) || request?.status === STATUS_TYPES.INIT_STATE,
  };
}
